export const MEDIA_POSITIONS = ['left', 'right'] as const;
